import { render, staticRenderFns } from "./header-buyer.vue?vue&type=template&id=2ec5b582&scoped=true&"
import script from "./header-buyer.vue?vue&type=script&lang=js&"
export * from "./header-buyer.vue?vue&type=script&lang=js&"
import style0 from "./header-buyer.vue?vue&type=style&index=0&id=2ec5b582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec5b582",
  null
  
)

export default component.exports